import React from 'react'

function ManagerDashboard() {
  return (
    <div>ManagerDashboard</div>
  )
}

export default ManagerDashboard